import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as AppStore } from '../assets/images/appstore.svg';
import { ReactComponent as PlayStore } from '../assets/images/googleplay.svg';
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLocation, getallCities } from "../redux/cities/citiesSlice";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Rider.css";

const Rider = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeDot, setActiveDot] = useState(0);
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const tr = t.rider;

  const { city, basePrice } = useSelector((state) => state.cities.currentLocation);
  const cc = useSelector((state) => state.cities.cities);

  useEffect(() => {
    dispatch(getCurrentLocation());
    dispatch(getallCities());
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDot(prev => (prev + 1) % 3);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayBasePrice = city ? basePrice.toFixed(2) : '9.95';
  const icons = ["family", "cash", "time", "friends", "free", "cars"];
  const safetyIcons = ["security", "file", "headphone"];

  return (
    <div>
      <div className="full-container">
        {/* Hero */}
        <div className="hero-sec">
          <div className="hero-text">
            <h1>{tr.heroTitle}</h1>
            <p>{tr.heroSubtitle}</p>
            <a href="https://apps.apple.com/us/app/berymo-free-rides-to-places/id1440035720">
              <button className="ridees">{tr.signUpToRide}</button>
            </a>
          </div>
          <div className="all-images">
            <img src="/images/rider.jpg" alt="rider" className="hero-image" />
          </div>
        </div>

        {/* Why Ride */}
        <div className="berymo-containers">
          <h2>{tr.whyRideTitle}</h2>
          <p className="berymo-subtexts">
            {tr.whyRideSubtitle1}{' '}
            <strong>{city || tr.whyRideSubtitleCity}</strong>{' '}
            {tr.whyRideSubtitle2}{' '}
            <strong>${displayBasePrice}</strong>{' '}
            {tr.whyRideSubtitle3}
          </p>

          <div className="berymo-grids">
            {tr.features.map((item, i) => (
              <div className="berymo-box" key={i}>
                <img src={`/images/${icons[i]}.png`} alt={icons[i]} className="icon" />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* How it Works */}
        <div className="work">
          <div className="works">
            <h4>{tr.howItWorksLabel}</h4>
            {tr.howItWorks.map((step, i) => (
              <div key={i}>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
            <div className="store-btn">
              <a href="https://apps.apple.com/us/app/berymo-free-rides-to-places/id1440035720" target="_blank" rel="noopener noreferrer">
                <AppStore />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.berymoflat" target="_blank" rel="noopener noreferrer">
                <PlayStore />
              </a>
            </div>
          </div>
          <div className="how-image">
            <div className="phone-frame">
              <img src="/images/iphoneX.png" alt="Phone" className="phone-bg" />
              <div className="scroll-wrapper">
                <div className="carousel" id="carousel">
                  <img src="/images/Theway.jpeg" alt="App UI" className="app-screen" />
                  <img src="/images/Lake.jpeg" alt="App UI" className="app-screens" />
                  <img src="/images/Jason.jpeg" alt="App UI" className="app-screenss" />
                </div>
              </div>
              <div className="dots">
                {[0, 1, 2].map((i) => (
                  <span key={i} className={`dot ${activeDot === i ? "active" : ""}`}></span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Driver Safety */}
        <div className="berymo-container">
          <h2>{tr.safetyTitle}</h2>
          <p className="berymo-subtext">{tr.safetySubtitle}</p>
          <div className="berymo-grid">
            {tr.safetyFeatures.map((item, i) => (
              <div className="berymo-box" key={i}>
                <img src={`/images/${safetyIcons[i]}.png`} alt={safetyIcons[i]} className="icon" />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
          <Link to="/safety" className="safety">{tr.safetyLink}</Link>
        </div>

        <div className="safety-images-section">
          <img src="/images/find-a-city.jpg" alt="Hero" className="safety-images" />
        </div>

        {/* FAQ */}
        <div className="faq-sections">
          <h1>{tr.faqTitle}</h1>
          <div className="faq-lists">
            {tr.faq.map((item, index) => (
              <div key={index} className="faq-items" onClick={() => toggleQuestion(index)}>
                <div className="faq-questions">
                  <span>{item.question}</span>
                  <span className="plus-icon">{activeIndex === index ? "×" : "+"}</span>
                </div>
                <div className={`faq-answers ${activeIndex === index ? 'open' : ''}`}>
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="signup-section">
          <h1>{tr.ctaTitle}</h1>
          <p>{tr.ctaSubtitle}</p>
          <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1">
            <button className="ride">{tr.signUpToRide}</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Rider;
